import { render } from "./work-center.vue?vue&type=template&id=2566e1dc"
import script from "./work-center.vue?vue&type=script&lang=js"
export * from "./work-center.vue?vue&type=script&lang=js"

import "./work-center.vue?vue&type=style&index=0&id=2566e1dc&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__